import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  modal: {
    width: "520px !important",
  },
  textUnlinkModal: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#475467",
  },
}));

export default styles;
